/**
 * External dependencies
 */

import React from 'react';
import { Select } from 'antd';

/**
 * Style dependencies
 */
import './styles.scss';

const FormComboBox = (props) => {
	const handleChange = (change) => {
		if (props.onChange) {
			props.onChange(change);
		}
	};

	return (
		<Select mode='tags' style={{ width: '100%' }} value={props.values} onChange={handleChange} {...props} />
	);
};

FormComboBox.defaultProps = {
	values: [],
};

export default FormComboBox;
